import { OutlinedTextFieldProps, StandardTextFieldProps, TextField } from '@mui/material';
import { ChangeEvent, useCallback, useState, FocusEvent } from 'react';

export const ControlledInputOnBlur = (props: OutlinedTextFieldProps | StandardTextFieldProps) => {
  const [state, setState] = useState<any>(props.value);

  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value);
  }, []);

  const handleOnBlur = useCallback((e: FocusEvent<HTMLInputElement>) => {
    props?.onChange?.({ target: { name: props.name, value: state } } as ChangeEvent<HTMLInputElement>);
    props?.onBlur?.(e);
  }, [props, state]);

  return (
    <TextField {...props} value={state} onChange={handleChange} onBlur={handleOnBlur}>
      {props.children}
    </TextField>
  );
};